import { render, staticRenderFns } from "./_menu-filters.vue?vue&type=template&id=3d5e2aae&scoped=true&"
import script from "./_menu-filters.vue?vue&type=script&lang=js&"
export * from "./_menu-filters.vue?vue&type=script&lang=js&"
import style0 from "./_menu-filters.vue?vue&type=style&index=0&id=3d5e2aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5e2aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon,VMenu})
